import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import store from '../../store';
import { CHANGE_PAGE_action } from '../../store/actions/pageAction';
import { CREATE_EVENT_action } from '../../store/actions/eventAction';


// Componentes de Material UI
import { Button, Card, Avatar, ToggleButtonGroup, ToggleButton, Container, Divider, AvatarGroup, Pagination, TextField, Box, Grid, Paper } from '@mui/material';
import Chip from '@mui/material-next/Chip';



import hamburguesa from '../../images/hamburguesa.jpg'

// Iconos
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import HomeIcon from '@mui/icons-material/Home';

import CryptoJS from "crypto-js";

import PropTypes from 'prop-types';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Skeleton from '@mui/material/Skeleton';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'; // Tres puntos horizontales
import VisibilityIcon from '@mui/icons-material/Visibility'; // Ojo on
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'; // Ojo off
import MessageIcon from '@mui/icons-material/Message';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded'; // Para agregar contacto
import GroupIcon from '@mui/icons-material/Group';
import InfoIcon from '@mui/icons-material/Info';

// Iconos para las privacidades
import PublicIcon from '@mui/icons-material/Public';
import HttpsIcon from '@mui/icons-material/Https';
import { Stack } from 'react-bootstrap';
import SidebarResponsive from '../../components/SidebarResponsive';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { AspectRatio } from '@mui/joy';
import CateringCard from '../../components/Cards/CateringCard';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import axios from 'axios';


// Componentes de Joy UI




const mapStateToProps = (state) => {
  return {
    eventDetailsReducer: state.eventDetailsReducer,
  }
}

const Map = ({ location }) => {
  useEffect(() => {
    console.log(location)
    let map;

    const initMap = async () => {
      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode({ location: location }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            console.log("Dirección encontrada:", results[0].formatted_address);
          } else {
            console.log("No se encontraron resultados.");
          }
        } else {
          console.error("Fallo en la geocodificación inversa: " + status);
        }
      });

      const position = { lat: location.lat, lng: location.lng };
      // const position = { lat: -32.4311892, lng: -63.72867609999999 };

      // Cargar bibliotecas de Google Maps
      const { Map } = await window.google.maps.importLibrary('maps');
      const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');
      map = new Map(document.getElementById('map'), {
        zoom: 15,
        center: position,
        mapId: 'DEMO_MAP_ID',
      });

      new AdvancedMarkerElement({
        map: map,
        position: position,
        title: 'Uluru',
      });
    };

    initMap();
  }, []);

  return <div id="map"
    style={{
      height: '100%', width: '100%', marginInline: 'auto',
      // borderRadius: 20 
    }}></div>;
};



function Media(props) {
  const { loading = false } = props;
  const navigate = useNavigate();




  const openEventDetails = () => {
    navigate("/eventdetails/14")
    // return <Navigate to="/createevent" />;
  }




  return (
    <Card sx={{ width: 345, m: 2 }}>
      <CardHeader
        avatar={
          loading ? (
            <Skeleton animation="wave" variant="circular" width={40} height={40} />
          ) : (
            <>
              <Avatar
                alt="Ted talk"
                src={props.creatorAvatar}
              />
            </>
          )
        }
        // action={
        //     loading ? null : (
        //         <IconButton aria-label="settings">
        //             <MoreVertIcon />
        //         </IconButton>
        //     )
        // }
        title={
          loading ? (
            <Skeleton
              animation="wave"
              height={10}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          ) : (
            <div style={{ display: 'flex' }}>
              <p>{props.title}</p>
              {props.privacity == 'Publico' ? <PublicIcon style={{ marginLeft: 16, color: '#3f51b5' }}></PublicIcon> : <HttpsIcon style={{ marginLeft: 16, color: '#ff9800' }}></HttpsIcon>}




            </div>
          )
        }
        subheader={
          loading ? (
            <Skeleton animation="wave" height={10} width="40%" style={{ marginTop: 8 }} />
          ) : (
            <Stack direction="row" spacing={1} style={{ marginTop: 8 }}>
              <Chip label={props.fecha} color="primary" size="small" variant="outlined" style={{ marginRight: 4 }} />
              •
              <Chip label="15:30" color="success" size="small" variant="outlined"
                style={{ marginLeft: 4 }} />
            </Stack>
          )
        }
      />
      {loading ? (
        <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" />
      ) : (
        <CardMedia
          component="img"
          height="140"
          image={props.image}
          alt="Nicola Sturgeon on a TED talk stage"
        />
      )}


      <CardContent>
        {loading ? (
          <React.Fragment>
            <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
            <Skeleton animation="wave" height={10} width="80%" />
          </React.Fragment>
        ) : (
          <Typography variant="body2" color="text.secondary" component="p">
            {
              props.description
            }
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}


Media.propTypes = {
  loading: PropTypes.bool,
};






// MAIN
const EventDetails = (props) => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const navigate = useNavigate();
  const { slug } = useParams();

  // Datos para la creacion de un evento
  const [eventName, setEventName] = useState('')
  const [eventDescription, setEventDescription] = useState('')
  const [eventCreator, setEventCreator] = useState('(Nombre del usuario actual)')
  let [eventType, setEventType] = useState('')
  // const [eventHour, setEventHour] = useState('15:00') // Hora del evento a crear

  let [showButton, setShowButton] = useState(false)

  const [eventHour, setEventHour] = useState(null)
  const [traducedHour, setTraducedHour] = useState(null)


  const [selectedDate, setSelectedDate] = useState(null)
  const [traducedDate, setTraducedDate] = useState(null)

  const [guestsView, setGuestsView] = useState(false)
  const [event, setEvent] = useState({
    title: '',
    description: '',
    creator: '',
    creatorAvatar: '',
    image: '',
    startDay: '',
    startTime: '',
    location: '',
    locationCoords: '',
    caracteristics: ''
  });


  const [filter, setFilter] = useState([
    { id: 0, title: 'Todos', selected: true },
    { id: 1, title: 'Publico', selected: false },
    { id: 2, title: 'Privados', selected: false },
    { id: 3, title: 'Creados por mí', selected: false },
  ])

  const [parentCoords, setParentCoords] = useState({
    lat: 40.712776,
    lng: -74.005974
  }); // Coordenadas iniciales de Nueva York


  const [modalCreateEvent, setModalCreateEvent] = useState(false) // Modal para crear un evento
  const [selectedIndex, setSelectedIndex] = React.useState(0); // Filtro para mostrar Todos, Publicos o Privados


  const [destination] = useState({
    lat: 40.7128,  // Nueva York
    lng: -74.0060
  });

  const handleGetDirections = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const { latitude: userLat, longitude: userLng } = position.coords;
        const locationCoords = props.eventDetailsReducer?.locationCoords || event.locationCoords;
        const coords = JSON.parse(locationCoords);
        const url = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${coords.lat},${coords.lng}&travelmode=driving`;
        console.log(url);
        window.open(url, '_blank');
      }, (error) => {
        console.error('Error obteniendo ubicación:', error);
        alert('No se pudo obtener tu ubicación');
      });
    } else {
      alert('La geolocalización no es soportada por tu navegador');
    }
  };

  async function getEvento() {

    const data = {
      "slug": slug,
    }


    const token = localStorage.getItem('jwt_token');
    const headers = 'content-type: application/json; charset=utf-8'
    axios.post(`https://socializeapi.azurewebsites.net/api/GetEventBySlug`, data, {
      headers
    })
      .then(response => {
        localStorage.setItem('eventID', response.data.eventID.toString())
        setEvent({
          title: response.data.eventTitle,
          description: response.data.eventDescription,
          creator: response.data.creatorName,
          creatorAvatar: response.data.creatorAvatar,
          image: response.data.eventImage,
          startDay: response.data.startDay,
          startTime: response.data.startHour,
          location: response.data.eventLocation,
          locationCoords: response.data.eventLocationCoords,
          caracteristics: response.data.eventCharacteristics
        })
      })
      .catch(error => {
        console.log(`Error obteniendo los eventos: ${error}`);
      })
  }

  function autoInvite() {
    const headers = 'content-type: application/json; charset=utf-8'

    var eventID = localStorage.getItem('eventID');
    var userID = localStorage.getItem('userID');

    const data = {
      "eventID": eventID,
      "userID": userID,
      "loginWithKey": "true"
    }


    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    axios.put(`https://socializeapi.azurewebsites.net/api/UpdateEvent`, { data: data_encripted }, {
      // withCredentials: true,
      headers
    })
      .then(response => {
        localStorage.removeItem('eventID');
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });
  }

  useEffect(() => {


    if (slug) {
      localStorage.setItem('eventSlug', slug);
      getEvento() // trae los datos del evento en base al slug

      if (localStorage.getItem('userData') && event.title !== '') { // si el usuario esta logueado entra aca
        autoInvite() // auto invita al usuario al evento
      }
    }

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 960); // set the breakpoint here
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div>
      <Header actualPage={'eventdetails'}></Header>

      <div style={{
        backgroundColor: '#fafafa',
        display: 'flex',
        width: '100%',
        minHeight: '100dvh',
      }}>
        <Container maxWidth="lg">

          {/* Verifica si el evento existe y si ya ocurrio */}
          {((!props.eventDetailsReducer.title && !event.title)
          // || (new Date(props.eventDetailsReducer?.startDay || event.startDay) < new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))
          ) ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '80vh',
                textAlign: 'center',
                gap: 4,
                padding: 4,
                backgroundColor: '#fafafa',
                mt: 12
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 3
                }}
              >
                <EventBusyIcon
                  sx={{
                    fontSize: 120,
                    color: '#bdbdbd',
                    marginBottom: 2
                  }}
                />

                <CalendarTodayIcon
                  sx={{
                    fontSize: 80,
                    color: '#e0e0e0',
                    position: 'absolute',
                    top: '20%',
                    left: '20%',
                    opacity: 0.5,
                    transform: 'rotate(-15deg)'
                  }}
                />

                <AccessTimeIcon
                  sx={{
                    fontSize: 80,
                    color: '#e0e0e0',
                    position: 'absolute',
                    bottom: '20%',
                    right: '20%',
                    opacity: 0.5,
                    transform: 'rotate(15deg)'
                  }}
                />
              </Box>

              <Paper
                elevation={0}
                sx={{
                  padding: 4,
                  borderRadius: 3,
                  maxWidth: 600,
                  width: '100%',
                  backgroundColor: '#f5f5f5',
                  border: '2px dashed #e0e0e0'
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    marginBottom: 2,
                    color: '#424242',
                    fontWeight: 600,
                    fontFamily: "'Poppins', sans-serif"
                  }}
                >
                  Este evento ya no está disponible
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: '#757575',
                    marginBottom: 4,
                    fontSize: '1.1rem',
                    lineHeight: 1.6
                  }}
                >
                  El evento que estás buscando ha finalizado o no existe.
                  Por favor, verifica el enlace o busca otros eventos disponibles.
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate('/')}
                  startIcon={<HomeIcon />}
                  sx={{
                    textTransform: 'none',
                    borderRadius: 2,
                    padding: '10px 24px',
                    fontSize: '1.1rem',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 8px rgba(0,0,0,0.15)'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  Volver al inicio
                </Button>
              </Paper>
            </Box>
          ) : (
            isLargeScreen ? ( // version pc
              <>
                {/* HEADER */}
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4,
                    marginY: 8,
                    padding: 4,
                    overflow: 'visible',
                  }}
                >
                  {/* Hero Section with Image and Title */}
                  <Paper
                    elevation={3}
                    sx={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: 4,
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'scale(1.01)',
                      },
                    }}
                  >
                    {(props.eventDetailsReducer?.image || event.image) ? (
                      <CardMedia
                        component="img"
                        image={`${props.eventDetailsReducer?.image || event.image}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                        sx={{
                          height: isLargeScreen ? 400 : 250,
                          filter: 'brightness(0.7)',
                        }}
                      />
                    ) : (
                      <CardMedia
                        sx={{
                          background: `linear-gradient(45deg, 
                          rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1),
                          rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)
                      )`,
                          height: isLargeScreen ? 400 : 250,
                          filter: 'brightness(0.7)',
                        }}
                      />
                    )}







                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                        padding: 4,
                        color: 'white',
                      }}
                    >
                      <Typography
                        variant={isLargeScreen ? 'h4' : 'h5'}
                        sx={{
                          marginBottom: 2,
                          fontWeight: 700,
                          color: 'white',
                          textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          letterSpacing: '0.5px',
                          animation: 'fadeIn 0.5s ease-in',
                          '@keyframes fadeIn': {
                            from: { opacity: 0, transform: 'translateY(20px)' },
                            to: { opacity: 1, transform: 'translateY(0)' }
                          }
                        }}
                      >
                        {props.eventDetailsReducer?.title || event.title}
                      </Typography>

                      <Typography
                        variant="h6"
                        // fontFamily='Trebuchet MS'
                        sx={{
                          opacity: 0.85,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          lineHeight: 1.6,
                          // fontSize: '0.95rem',
                          fontWeight: 300,
                          letterSpacing: '0.3px',
                          fontStyle: 'italic',
                          textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                          fontFamily: '"Segoe UI", Arial, sans-serif'
                        }}
                      >
                        {props.eventDetailsReducer?.description || event.description}
                      </Typography>
                    </Box>
                  </Paper>

                  {/* Host Information */}
                  <Paper
                    elevation={2}
                    sx={{
                      padding: 3,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 3,
                      borderRadius: 2,
                      transition: 'transform 0.2s',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                      }
                    }}
                  >
                    <Avatar
                      src={`${props.eventDetailsReducer?.creatorAvatar || event.creatorAvatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                      sx={{
                        width: 100,
                        height: 100,
                        border: '4px solid #5c6bc0',
                      }}
                    />
                    <Box>
                      <Typography variant="h5" fontFamily="Fredoka, sans-serif">
                        {props.eventDetailsReducer?.creator || event.creator}
                      </Typography>
                      <Typography color="text.secondary" fontFamily="Fredoka, sans-serif">
                        Anfitrión
                      </Typography>
                    </Box>
                  </Paper>

                  {/* Event Details Cards */}
                  <Grid container spacing={3}>
                    {/* Date and Time Card */}
                    <Grid item xs={12} md={6}>
                      <Paper
                        elevation={2}
                        sx={{
                          padding: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          borderRadius: 2,
                          height: '100%',
                          minHeight: 360,
                          transition: 'all 0.3s',
                          '&:hover': {
                            backgroundColor: '#f5f5f5',
                          }
                        }}
                      >
                        <Box sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%',
                          gap: 3
                        }}>
                          <AccessTimeIcon sx={{ fontSize: 40, color: '#5c6bc0' }} />

                          <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 3,
                            background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
                            padding: 4,
                            borderRadius: 4,
                            boxShadow: '10px 10px 20px #d9d9d9, -10px -10px 20px #ffffff',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              transform: 'translateY(-5px)',
                              boxShadow: '15px 15px 30px #d9d9d9, -15px -15px 30px #ffffff'
                            }
                          }}>
                            <Typography
                              variant="h5"
                              fontFamily="'Poppins', sans-serif"
                              sx={{
                                color: '#2c3e50',
                                fontWeight: 500,
                                textAlign: 'center',
                                letterSpacing: '1px',
                                textTransform: 'uppercase',
                                marginBottom: 0.5
                              }}
                            >
                              {(new Date(props.eventDetailsReducer?.startDay || event.startDay)).toLocaleDateString("es-ES", {
                                day: 'numeric',
                                month: 'long'
                              })}
                            </Typography>

                            <Typography
                              variant="h2"
                              fontFamily="'Montserrat', sans-serif"
                              sx={{
                                background: 'linear-gradient(135deg, #6366f1 0%, #3b82f6 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                fontWeight: 800,
                                textAlign: 'center',
                                fontSize: '4rem',
                                lineHeight: 1,
                                marginBottom: 2
                              }}
                            >
                              {props.eventDetailsReducer?.startTime || event.startTime}
                            </Typography>

                            <Divider sx={{
                              width: '60%',
                              margin: '8px 0',
                              background: 'linear-gradient(90deg, transparent, #6366f1, transparent)',
                              height: '2px'
                            }} />

                            <Typography
                              variant="subtitle1"
                              fontFamily="'Poppins', sans-serif"
                              sx={{
                                color: '#64748b',
                                fontWeight: 500,
                                textAlign: 'center',
                                letterSpacing: '0.5px'
                              }}
                            >
                              Fecha y hora de inicio
                            </Typography>
                          </Box>

                          {/* <Divider sx={{ width: '80%', margin: '16px 0' }} />
  
                          <Box>
                            <Typography variant="h6" fontFamily="Fredoka, sans-serif" gutterBottom>
                              Detalles del horario
                            </Typography>
                            <Typography color="text.secondary" paragraph>
                              El evento comenzará puntualmente a la hora indicada. Se recomienda llegar con 15 minutos de anticipación.
                            </Typography>
                          </Box> */}
                        </Box>
                      </Paper>
                    </Grid>

                    {/* Location Card */}
                    <Grid item xs={12} md={6}>
                      <Paper
                        elevation={2}
                        sx={{
                          padding: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 2,
                          borderRadius: 2,
                          height: '100%',
                          minHeight: 360
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <LocationOnIcon sx={{ fontSize: 40, color: '#5c6bc0' }} />
                          <Typography variant="h7" fontFamily="Fredoka, sans-serif">
                            {(props.eventDetailsReducer.location || event.location) || 'Ubicación no especificada'}
                          </Typography>
                        </Box>

                        {(props.eventDetailsReducer.location || event.location) && (
                          <>
                            <Button
                              variant="contained"
                              onClick={handleGetDirections}
                              startIcon={<ModeOfTravelIcon />}
                              sx={{
                                borderRadius: 30,
                                textTransform: 'none',
                                transition: 'all 0.3s',
                                '&:hover': {
                                  transform: 'scale(1.05)',
                                }
                              }}
                            >
                              ¿Cómo llegar?
                            </Button>
                            <Box sx={{ flexGrow: 1, borderRadius: 2, overflow: 'hidden' }}>
                              <Map location={JSON.parse(props.eventDetailsReducer.locationCoords || event.locationCoords)} />
                            </Box>
                          </>
                        )}
                      </Paper>
                    </Grid>
                  </Grid>

                  {/* Additional Details Section */}
                  {(props.eventDetailsReducer.caracteristics || event.caracteristics) && (
                    <Paper
                      elevation={2}
                      sx={{
                        marginTop: 4,
                        padding: 3,
                        borderRadius: 2,
                        backgroundColor: '#f8f9fa',
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginBottom: 2 }}>
                        <InfoIcon sx={{ color: '#5c6bc0', fontSize: 32 }} />
                        <Typography variant="h6" fontFamily="Fredoka, sans-serif">
                          Detalles adicionales
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          whiteSpace: 'pre-wrap',
                          fontFamily: 'Fredoka, sans-serif',
                          lineHeight: 1.6
                        }}
                      >
                        {props.eventDetailsReducer.caracteristics || event.caracteristics}
                      </Typography>
                    </Paper>
                  )}
                </Box>
              </>
            ) : ( // version movil
              <>

                {/* HEADER */}
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: isLargeScreen ? 4 : 2,
                    marginY: isLargeScreen ? 8 : 4,
                    padding: isLargeScreen ? 4 : 0,
                    overflow: 'visible',
                  }}
                >
                  {/* Hero Section */}
                  <Paper
                    elevation={3}
                    sx={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: 0,
                      width: '100vw',
                      marginLeft: 'calc(-50vw + 50%)',
                      marginRight: 'calc(-50vw + 50%)',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: isLargeScreen ? 'scale(1.01)' : 'none',
                      },
                    }}
                  >
                    {(props.eventDetailsReducer?.image || event.image) ? (
                      <CardMedia
                        component="img"
                        image={`${(props.eventDetailsReducer?.image || event.image)}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                        sx={{
                          width: '100%',
                          height: isLargeScreen ? '70vh' : '40vh',
                          objectFit: 'cover',
                          filter: 'brightness(0.7)',
                        }}
                      />
                    ) : (
                      <CardMedia
                        sx={{
                          background: `linear-gradient(45deg, 
                          rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1),
                          rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)
                      )`,
                          height: isLargeScreen ? 400 : 250,
                          filter: 'brightness(0.7)',
                        }}
                      />
                    )}

                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                        padding: isLargeScreen ? '4rem' : '2rem',
                        color: 'white',
                      }}
                    >
                      <Typography
                        variant={'h5'}
                        sx={{
                          marginBottom: 1,
                          fontWeight: 700,
                          color: 'white',
                          textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          letterSpacing: '0.5px',
                          animation: 'fadeIn 0.5s ease-in',
                          '@keyframes fadeIn': {
                            from: { opacity: 0, transform: 'translateY(20px)' },
                            to: { opacity: 1, transform: 'translateY(0)' }
                          }
                        }}
                      >
                        {props.eventDetailsReducer?.title || event.title}
                      </Typography>

                      <Typography
                        variant={"h7"}
                        sx={{
                          opacity: 0.85,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          whiteSpace: 'normal',
                          lineHeight: 1.6,
                          fontWeight: 300,
                          letterSpacing: '0.3px',
                          fontStyle: 'italic',
                          textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                          fontFamily: '"Segoe UI", Arial, sans-serif',
                          maxWidth: 'calc(100% - 48px)',
                        }}
                      >
                        {props.eventDetailsReducer?.description || event.description}
                      </Typography>
                    </Box>
                  </Paper>

                  {/* Host Information - Responsive layout */}
                  <Paper
                    elevation={0}
                    sx={{
                      padding: isLargeScreen ? 3 : 2,
                      display: 'flex',
                      flexDirection: isLargeScreen ? 'row' : 'column',
                      alignItems: 'center',
                      gap: 2,
                      borderRadius: 2,
                      textAlign: isLargeScreen ? 'left' : 'center'
                    }}
                  >
                    <Avatar
                      src={`${props.eventDetailsReducer?.creatorAvatar || event.creatorAvatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                      sx={{
                        width: isLargeScreen ? 100 : 80,
                        height: isLargeScreen ? 100 : 80,
                        // border: '4px solid #5c6bc0',
                      }}
                    />
                    <Box>
                      <Typography variant={isLargeScreen ? "h5" : "h6"} fontFamily="Fredoka, sans-serif">
                        {props.eventDetailsReducer?.creator || event.creator}
                      </Typography>
                      <Typography color="text.secondary" fontFamily="Fredoka, sans-serif">
                        Anfitrión
                      </Typography>
                    </Box>
                  </Paper>












                  {/* Event Details Cards - Responsive Grid */}
                  <Grid
                    container
                    spacing={isLargeScreen ? 3 : 2}
                    sx={{ height: 200 }}
                    style={{

                      display: 'flex'
                    }}>

                    <Grid item xs={6} md={6}
                      sx={{ height: '100%' }}>
                      <Paper
                        elevation={0}
                        sx={{
                          // padding: 2,
                          height: '100%',  // Usa 100% en lugar de 'auto'
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          overflow: 'hidden',  // Evita desbordamiento
                        }}
                      >
                        <Box sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 2,
                          height: '100%',
                          justifyContent: 'center',
                          overflow: 'auto'  // Permite scroll si el contenido es demasiado grande
                        }}>
                          <Box sx={{
                            textAlign: 'center',
                            padding: isLargeScreen ? 3 : 2,
                          }}>
                            <Typography variant={isLargeScreen ? "h6" : "subtitle1"}>
                              {(new Date(props.eventDetailsReducer?.startDay || event.startDay)).toLocaleDateString("es-ES", {
                                day: 'numeric',
                                month: 'long'
                              })}
                            </Typography>

                            <Typography
                              variant={isLargeScreen ? "h4" : "h5"}
                              sx={{
                                background: 'linear-gradient(135deg, #6366f1 0%, #3b82f6 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                fontWeight: 700,
                                marginBottom: 2
                              }}
                            >
                              {props.eventDetailsReducer?.startTime || event.startTime}
                            </Typography>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                fontStyle: 'italic'
                              }}
                            >
                              Día y hora de inicio del evento
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>


                    {(props.eventDetailsReducer.location || event.location) && (

                      <Grid item xs={6} md={6} style={{ height: '100%' }}>
                        <Paper
                          elevation={0}
                          onClick={() => {
                            if (!showButton) {
                              setShowButton(true);
                              setTimeout(() => setShowButton(false), 3000);
                            }
                          }}
                          sx={{
                            padding: 2,
                            height: 'calc(100% - 32px)', 
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            position: 'relative',
                          }}
                        >
                          <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            height: '100%',
                            justifyContent: 'space-between',
                            overflow: 'auto'
                          }}>
                            <Box sx={{
                              display: 'flex',
                              alignItems: 'center', 
                              justifyContent: 'center',
                              position: 'relative',
                              zIndex: 2,
                              opacity: showButton ? 0 : 1,
                              transition: 'opacity 0.3s ease',
                              padding: 1,
                              height: '100%',
                            }}>
                              <ModeOfTravelIcon
                                sx={{
                                  position: 'absolute',
                                  fontSize: '3rem',
                                  opacity: 0.1,
                                  zIndex: 1
                                }}
                              />
                              <Typography
                                variant="body1"
                                fontFamily="Fredoka, sans-serif"
                                sx={{
                                  fontSize: ((props.eventDetailsReducer.location || event.location || '').length > 30) ? '0.8rem' : '0.9rem',
                                  textAlign: 'center',
                                  position: 'relative',
                                  zIndex: 2
                                }}
                              >
                                {(props.eventDetailsReducer.location || event.location) || 'Ubicación no especificada'}
                              </Typography>
                            </Box>

                            {(props.eventDetailsReducer.location || event.location) && (
                              <Button
                                variant="contained"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleGetDirections();
                                }}
                                sx={{
                                  position: 'absolute',
                                  bottom: 0,
                                  right: 0,
                                  width: '100%',
                                  height: '100%',
                                  borderRadius: 0,
                                  opacity: showButton ? 1 : 0,
                                  transform: showButton ? 'scale(1) translate(0, 0)' : 'scale(0) translate(50%, 50%)',
                                  transformOrigin: 'bottom right',
                                  transition: 'all 0.3s ease',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: 1,
                                  pointerEvents: showButton ? 'auto' : 'none',
                                  zIndex: 3
                                }}
                              >
                                <ModeOfTravelIcon sx={{ fontSize: 24 }} />
                                <span>¿Cómo llegar?</span>
                              </Button>
                            )}
                          </Box>
                        </Paper>
                      </Grid>
                    )}


                    {(props.eventDetailsReducer.location == "" && event.location == "") && (
                      <Grid item xs={6} md={6} style={{ height: '100%' }}>
                        <Paper
                          elevation={0}
                          sx={{
                            padding: 2,
                            height: 'calc(100% - 32px)',
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            position: 'relative',
                            // '&:hover': {
                            //   backgroundColor: '#f5f5f5'
                            // }
                          }}
                        >
                          <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            height: '100%',
                            justifyContent: 'space-between',
                            overflow: 'auto'
                          }}>
                            <Box sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              position: 'relative',
                              zIndex: 2,
                              opacity: 1,
                              transition: 'opacity 0.3s ease',
                              padding: 1,
                              height: '100%',
                            }}>
                              <ModeOfTravelIcon
                                sx={{
                                  position: 'absolute',
                                  fontSize: '3rem',
                                  opacity: 0.1,
                                  zIndex: 1
                                }}
                              />
                              <Typography
                                variant="body1"
                                fontFamily="Fredoka, sans-serif"
                                sx={{
                                  fontSize: ((props.eventDetailsReducer.location || event.location || '').length > 30) ? '0.8rem' : '0.9rem',
                                  textAlign: 'center',
                                  position: 'relative',
                                  zIndex: 2
                                }}
                              >
                                {(props.eventDetailsReducer.location || event.location) || 'Ubicación no especificada'}
                              </Typography>
                            </Box>


                          </Box>
                        </Paper>
                      </Grid>

                    )}
                  </Grid>



                  {(props.eventDetailsReducer.location || event.location) && (
                    <Grid container rowSpacing={2} sx={{ width: '100%', mt: 2 }}>
                      <Grid item xs={12}>
                        <Paper
                          elevation={0}
                          sx={{
                            borderRadius: 2,
                            transition: 'transform 0.2s',
                            '&:hover': {
                              transform: 'translateY(-4px)',
                            }
                          }}
                        >
                          <Box sx={{ height: isLargeScreen ? 260 : 200, borderRadius: 2, overflow: 'hidden' }}>
                            <Map location={JSON.parse(props.eventDetailsReducer.locationCoords || event.locationCoords)} />
                          </Box>
                        </Paper>
                      </Grid>
                    </Grid>
                  )}


                  {/* Additional Details Section - Responsive */}
                  {(props.eventDetailsReducer.caracteristics || event.caracteristics) && (
                    <Paper
                      elevation={2}
                      sx={{
                        marginTop: isLargeScreen ? 4 : 4,
                        padding: isLargeScreen ? 3 : 2,
                        borderRadius: 2,
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginBottom: 2 }}>
                        <InfoIcon sx={{ color: '#5c6bc0', fontSize: isLargeScreen ? 32 : 24 }} />
                        <Typography variant={isLargeScreen ? "h6" : "subtitle1"} fontFamily="Fredoka, sans-serif">
                          Detalles adicionales
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          whiteSpace: 'pre-wrap',
                          fontFamily: 'Fredoka, sans-serif',
                          fontSize: isLargeScreen ? '1rem' : '0.875rem',
                        }}
                      >
                        {props.eventDetailsReducer.caracteristics || event.caracteristics}
                      </Typography>
                    </Paper>
                  )}
                </Box>
              </>
            )

          )}

        </Container>

      </div>


    </div>
  )


}


export default connect(mapStateToProps)(EventDetails);